exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".feed-1 {\n  fill: none;\n}\n\n.feed-2 {\n  fill: #fff;\n}\n\n.feed-3 {\n  fill: #644f16;\n}\n\n.feed-4 {\n  fill: #ff9300;\n}\n", ""]);
